import React from 'react';
import _ from 'lodash';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { SaveFolderForm } from 'modules/components/layer12';
import { useParams } from 'react-router-dom';

export type SaveFolderProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveFolderProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title={_.isNil(props.id) ? 'Create Folder' : 'Edit Folder'}
      subTitle='Enter folder name to save create new folder.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveFolderForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
